import store                                             from "@/store";
import { getModule, Module, MutationAction, VuexModule } from "vuex-module-decorators";

@Module({
    namespaced: true,
    name      : "commonModule",
    store,
    dynamic   : true
})
class CommonModule extends VuexModule {
    isLoading           = false;
    isLoadingFullscreen = false;

    @MutationAction({mutate: ["isLoading"]})
    public async setLoading(isLoading: boolean) {

        return ({isLoading});
    }

    @MutationAction({mutate: ["isLoadingFullscreen"]})
    public async setFullscreen(isLoadingFullscreen: boolean) {

        return ({isLoadingFullscreen});
    }
    
    get loading(){
        return this.isLoading;
    }
    
    get fullscreen(){
        return this.isLoadingFullscreen;
    }
}

export default getModule(CommonModule);
